/** @format */
import { SisStateDeclaration } from '../router/types';
import { FeedbackComponent } from './feedback.component';
import { FeedbackThankYouComponent } from './thank-you/feedback-thank-you.component';

export const feedbackPath = 'feedback';
const feedbackThankYouPath = 'thank-you';

export const genericFeedbackState: Partial<SisStateDeclaration> = {
    url: `/${feedbackPath}`,
    component: FeedbackComponent,
    data: {
        browserTabTitle: 'FEEDBACK.TITLE',
        showHome: true,
        showHeader: true,
        hideLastNode: false,
    },
    headerParams: {
        displayNameKey: 'FEEDBACK.TITLE',
        skipBreadcrumb: false,
    },
};

export const genericFeedbackThankYouState: Partial<SisStateDeclaration> = {
    url: `/${feedbackPath}/${feedbackThankYouPath}`,
    component: FeedbackThankYouComponent,
    data: {
        browserTabTitle: 'FEEDBACK.THANK_YOU.TITLE',
        showHome: true,
        showHeader: true,
        hideLastNode: false,
    },
    headerParams: {
        displayNameKey: 'FEEDBACK.TITLE',
        displayPageTitleNameKey: 'FEEDBACK.THANK_YOU.TITLE',
    },
};
